import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import './UserMenu.css';

export function UserMenu() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  async function handleLogout() {
    setOpen(false);
    await logout();
    navigate('/login', { replace: true });
  }

  if (!user) return null;

  return (
    <div className="fa-user-menu" ref={containerRef}>
      <button
        type="button"
        className="fa-user-menu__trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={t('topbar.profileMenu')}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="fa-user-menu__avatar" aria-hidden="true">
          {user.fullName.trim().charAt(0).toUpperCase()}
        </span>
        <span className="fa-user-menu__name">{user.fullName}</span>
      </button>

      {open && (
        <div className="fa-user-menu__dropdown" role="menu">
          <div className="fa-user-menu__role" role="none">
            {user.role}
          </div>
          <button
            type="button"
            role="menuitem"
            className="fa-user-menu__item"
            onClick={handleLogout}
          >
            {t('topbar.logout')}
          </button>
        </div>
      )}
    </div>
  );
}
